import React from 'react';

const ArStep1_1 = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="262"
      height="178"
      viewBox="0 0 262 178"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M261 173H0.999988" stroke="#33415C" strokeLinecap="round" />
      <path
        d="M186.5 176V56.0136C186.5 54.2064 184.293 53.326 183.049 54.637L69.2038 174.623C67.9947 175.898 68.898 178 70.6546 178H184.5C185.605 178 186.5 177.105 186.5 176Z"
        fill="url(#paint0_linear_687_6510)"
      />
      <rect
        width="18"
        height="4"
        rx="2"
        transform="matrix(-0.809185 -0.587554 -0.588017 0.808849 198 56)"
        fill="#33415C"
      />
      <circle r="17" transform="matrix(-1 0 0 1 229 17)" fill="#ADB5BD" />
      <path
        d="M233.492 40.5509C233.933 33.8002 242.746 32 244.95 32C257.318 32 258.602 41.8397 259.483 48.5889L259.491 48.6518C260.372 55.4026 259.932 77.905 259.491 84.2057C259.051 90.5064 258.61 90.9564 255.525 95.4569C252.441 99.9574 251.559 117.959 251.119 126.96C250.678 135.961 252.881 148.113 253.763 150.813C254.644 153.513 259.932 171.065 246.712 171.965C233.492 172.865 231.289 156.214 232.17 126.96C233.052 97.7072 238.34 95.4569 235.255 92.3066C232.17 89.1562 233.492 78.8863 233.492 73.8546V50.9021C233.492 49.1019 233.052 47.3017 233.492 40.5509Z"
        fill="#ADB5BD"
      />
      <mask
        id="mask0_687_6510"
        // style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="232"
        y="32"
        width="28"
        height="140"
      >
        <path
          d="M233.492 40.5509C233.933 33.8002 242.746 32 244.95 32C257.318 32 258.602 41.8397 259.483 48.5889L259.491 48.6518C260.372 55.4026 259.932 77.905 259.491 84.2057C259.051 90.5064 258.61 90.9564 255.525 95.4569C252.441 99.9574 251.559 117.959 251.119 126.96C250.678 135.961 252.881 148.113 253.763 150.813C254.644 153.513 259.932 171.065 246.712 171.965C233.492 172.865 231.289 156.214 232.17 126.96C233.052 97.7072 238.34 95.4569 235.255 92.3066C232.17 89.1562 233.492 78.8863 233.492 73.8546V50.9021C233.492 49.1019 233.052 47.3017 233.492 40.5509Z"
          fill="#ADB5BD"
        />
      </mask>
      <g mask="url(#mask0_687_6510)">
        <path
          d="M248.212 49.0331L232.47 69.5233L232.068 75.929L235.704 79.584L246.854 71.3324L249.199 53.9431L248.212 49.0331Z"
          fill="url(#paint1_linear_687_6510)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M230.06 72.5843C230.616 72.2067 231.119 71.7286 231.538 71.1545L248.642 47.7355C250.597 45.0595 250.008 41.3105 247.328 39.3618C244.648 37.4132 240.891 38.0028 238.936 40.6788L223.276 62.1204L200.879 55.4889C197.966 54.6266 194.903 56.2878 194.037 59.1993C193.171 62.1108 194.83 65.1701 197.743 66.0325L224.591 73.9815C226.598 74.576 228.678 73.9712 230.06 72.5843Z"
        fill="#ADB5BD"
      />
      <circle r="2.5" transform="matrix(-1 0 0 1 134.5 160.5)" fill="#06D6A0" />
      <circle r="2.5" transform="matrix(-1 0 0 1 127.5 167.5)" fill="#06D6A0" />
      <circle r="2.5" transform="matrix(-1 0 0 1 113.5 162.5)" fill="#06D6A0" />
      <circle r="2.5" transform="matrix(-1 0 0 1 101.5 164.5)" fill="#06D6A0" />
      <circle r="2.5" transform="matrix(-1 0 0 1 84.5 167.5)" fill="#06D6A0" />
      <circle r="2.5" transform="matrix(-1 0 0 1 145.5 167.5)" fill="#06D6A0" />
      <circle r="2.5" transform="matrix(-1 0 0 1 178.5 162.5)" fill="#06D6A0" />
      <circle r="2.5" transform="matrix(-1 0 0 1 165.5 167.5)" fill="#06D6A0" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.0736 13.2154L56.2031 0L54.3326 13.2155C52.1704 13.3822 50.0879 13.8355 48.1227 14.5375L41.071 3.23415L44.707 16.0689C42.8328 17.092 41.1084 18.3575 39.5754 19.8234L28.5553 12.3774L37.0712 22.6184C35.784 24.2993 34.7111 26.1546 33.8934 28.143L20.8202 25.8488L32.7385 31.7197C32.3025 33.5444 32.0716 35.4495 32.0716 37.4087C32.0716 37.6288 32.0745 37.8481 32.0803 38.0667L19.2031 41.319L32.4672 41.808C32.8559 43.9424 33.5224 45.9791 34.4275 47.879L23.9837 56.1131L36.3006 51.1344C37.5049 52.8966 38.9345 54.4908 40.5478 55.875L34.3353 67.673L43.5725 58.0884C45.3637 59.1969 47.3098 60.0768 49.3706 60.6874L48.468 74L53.0297 61.4658C54.0684 61.6031 55.1279 61.6739 56.2038 61.6739C57.2793 61.6739 58.3383 61.6031 59.3766 61.466L63.9382 74L63.0357 60.6878C65.0966 60.0772 67.0429 59.1974 68.8342 58.089L78.071 67.673L71.8588 55.8758C73.4724 54.4915 74.9023 52.8971 76.1067 51.1349L88.4226 56.1131L77.9797 47.8797C78.885 45.9796 79.5516 43.9426 79.9404 41.808L93.2031 41.319L80.3273 38.067C80.3331 37.8483 80.336 37.6289 80.336 37.4087C80.336 35.4493 80.105 33.544 79.6689 31.7191L91.586 25.8488L78.5141 28.1428C77.6963 26.1542 76.6231 24.2986 75.3357 22.6175L83.8509 12.3774L72.8316 19.8229C71.2985 18.3569 69.5739 17.0914 67.6994 16.0683L71.3353 3.23415L64.2838 14.5371C62.3185 13.8351 60.2359 13.382 58.0736 13.2154Z"
        fill="#FFD166"
      />
      <defs>
        <linearGradient
          id="paint0_linear_687_6510"
          x1="183.956"
          y1="53.6926"
          x2="170.008"
          y2="175.299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#06D6A0" />
          <stop offset="1" stopColor="#06D6A0" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_687_6510"
          x1="240.921"
          y1="51.6675"
          x2="247.544"
          y2="55.7428"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.107993" stopColor="#33415C" />
          <stop offset="0.89927" stopColor="#C4C4C4" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArStep1_1;
